// extracted by mini-css-extract-plugin
var _1 = "CommentCreate-module__actions--yGiEY";
var _2 = "CommentCreate-module__animateUploadProgressBarWidth--UJl94";
var _3 = "CommentCreate-module__animatedBackground--emn1f";
var _4 = "CommentCreate-module__avatar--uULXP";
var _5 = "CommentCreate-module__container--ciRXH";
var _6 = "CommentCreate-module__editor--Bm1B_";
var _7 = "CommentCreate-module__newThread--zWmbr";
export { _1 as "actions", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "avatar", _5 as "container", _6 as "editor", _7 as "newThread" }
